'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _min2 = require('lodash/min');
var _min3 = _interopRequireDefault(_min2);
var _max2 = require('lodash/max');
var _max3 = _interopRequireDefault(_max2);
var _curry2 = require('lodash/curry');
var _curry3 = _interopRequireDefault(_curry2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
exports.default = eauors;
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _utils = require('../utils');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function symbEnter(selection, options, selector) {
  (0, _utils.setupElement)(selection, 'svg:g', selector);
}
function markerOver(selectors, options, accessors, symbSelection, datum) {
  var shapeMarkers = symbSelection.selectAll((0, _utils.selector)(selectors.marker)).filter(function (d) {
    return d.marker === datum.marker;
  });
  var otherMarkers = symbSelection.selectAll((0, _utils.selector)(selectors.marker)).filter(function (d) {
    return d.marker !== datum.marker;
  });
  shapeMarkers.style({
    fill: function fill(d) {
      return (0, _utils.getOverColor)(options.serie, accessors.focusData(d));
    },
    stroke: function stroke(d) {
      return (0, _utils.getOverColor)(options.serie, accessors.focusData(d));
    }
  });
  otherMarkers.style({
    opacity: 0.5
  });
}
function markerOut(selectors, options, accessors, symbSelection, datum) {
  var shapeMarkers = symbSelection.selectAll((0, _utils.selector)(selectors.marker)).filter(function (d) {
    return d.marker === datum.marker;
  });
  var otherMarkers = symbSelection.selectAll((0, _utils.selector)(selectors.marker)).filter(function (d) {
    return d.marker !== datum.marker;
  });
  shapeMarkers.style({
    stroke: function stroke(datum) {
      return accessors.markerColor(options, 'stroke', datum);
    },
    fill: function fill(datum) {
      return accessors.markerColor(options, 'fill', datum);
    }
  });
  otherMarkers.style({
    opacity: 1
  });
}
function markerEnter(selection, options, selectors, accessors, symbSelection, hideTooltip) {
  (0, _utils.setupElement)(selection, 'svg:path', selectors.marker).on('mouseover', (0, _curry3.default)(markerOver)(selectors, options, accessors, symbSelection)).on('mouseout', (0, _curry3.default)(markerOut)(selectors, options, accessors, symbSelection)).on('mouseleave', (0, _curry3.default)(hideTooltip));
}
function markerUpdate(selection, options, accessors, _ref, showTooltip) {
  var xScale = _ref.xScale,
    yScale = _ref.yScale;
  selection.attr({
    d: function d(datum) {
      var marker = accessors.marker(options.serie, datum);
      var size = (0, _get3.default)(marker, 'size', options.serie.symbol.markerDefaultSize);
      return marker.path(size);
    },
    transform: function transform(datum) {
      var x = xScale(accessors.x(datum));
      var y = yScale(accessors.y(datum)) + yScale.rangeBand() / 2;
      var rotate = accessors.markerRotate(options, datum);
      return 'translate(' + x + ', ' + y + ') rotate(' + rotate + ')';
    }
  }).on('mousemove', function (datum) {
    var serie = _d2.default.select(this.parentNode).datum();
    showTooltip(options.serie, {
      xScale: xScale,
      yScale: yScale
    }, serie, datum);
  });
  selection.style({
    'stroke-width': function strokeWidth(datum) {
      return accessors.markerStrokeWidth(options, datum);
    },
    stroke: function stroke(datum) {
      return accessors.markerColor(options, 'stroke', datum);
    },
    fill: function fill(datum) {
      return accessors.markerColor(options, 'fill', datum);
    }
  });
}
function gapMinMaxEnter(selection, selectors) {
  (0, _utils.setupElement)(selection, 'svg:line', selectors.gapMinMaxLine);
}
function gapMinMaxUpdate(selection, options, accessors, scales) {
  selection.attr({
    x1: function x1(datum) {
      return '' + scales.xScale((0, _min3.default)(datum.values));
    },
    x2: function x2(datum) {
      return '' + scales.xScale((0, _max3.default)(datum.values));
    },
    y1: function y1(datum) {
      return '' + (scales.yScale(datum.category) + scales.yScale.rangeBand() / 2);
    },
    y2: function y2(datum) {
      return '' + (scales.yScale(datum.category) + scales.yScale.rangeBand() / 2);
    }
  });
  selection.style({
    'stroke-width': options.serie.symbol.gapMinMaxThickness,
    stroke: options.serie.symbol.gapMinMaxColor,
    'shape-rendering': 'crispEdges'
  });
}
function gapAxisMinEnter(selection, selectors) {
  (0, _utils.setupElement)(selection, 'svg:line', selectors.gapAxisMin);
}
function gapAxisMinUpdate(selection, options, accessors, scales, axisCoord) {
  selection.attr({
    x1: function x1(datum) {
      return '' + scales.xScale(axisCoord);
    },
    x2: function x2(datum) {
      return '' + scales.xScale((0, _min3.default)(datum.values));
    },
    y1: function y1(datum) {
      return '' + (scales.yScale(datum.category) + scales.yScale.rangeBand() / 2);
    },
    y2: function y2(datum) {
      return '' + (scales.yScale(datum.category) + scales.yScale.rangeBand() / 2);
    }
  });
  selection.style({
    'stroke-width': options.serie.symbol.gapAxisMinThickness,
    stroke: options.serie.symbol.gapAxisMinColor,
    'shape-rendering': 'crispEdges'
  });
}
function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    symbEnter: symbEnter,
    markerEnter: markerEnter,
    markerUpdate: markerUpdate,
    gapMinMaxEnter: gapMinMaxEnter,
    gapMinMaxUpdate: gapMinMaxUpdate,
    gapAxisMinEnter: gapAxisMinEnter,
    gapAxisMinUpdate: gapAxisMinUpdate
  });
}